<template>
  <el-upload
    class="upload-demo"
    :action="uploadDoc"
    :on-remove="handleRemove"
    :data="{ type: typeProps }"
    multiple
    :limit="maxCount"
    :on-exceed="handleExceed"
    :file-list="uploadfileList"
    :on-success="handleSuccess"
    v-model="uploadfileList"
    :before-upload="beforeAvatarUpload"
  >
    <el-button size="small" type="primary">点击上传</el-button>
    <div slot="tip" class="el-upload__tip">
      只能上传pdf,txt,doc,docx,xlsx,zip,tar文件，且不超过50MB
    </div>
  </el-upload>
</template>
<script>
import { uploadDoc } from "@/api/common";
import { UPLOAD_IMG_TYPE } from "@/utils/enumUtile";
import { getFileName } from "@/utils/utils";
import { Message } from "element-ui";

export default {
  computed: {
    uploadDoc() {
      return uploadDoc;
    }
  },
  props: {
    typeProps: UPLOAD_IMG_TYPE,
    paramsType: String,
    model: Array,
    maxCount: {
      type: Number
    } // 最大个数
  },
  data() {
    return {
      uploadfileList: [],
      disabled: false
    };
  },
  watch: {
    model(value) {
      this.setFileList(value);
    }
  },
  created() {
    if (this.model) {
      this.setFileList(this.model);
    }
  },
  methods: {
    /**
     * 设置图片
     * @param img
     */
    setFileList(img) {
      this.uploadfileList = img;
    },
    /**
     * 删除
     * @param file
     * @param fileList
     */
    handleRemove(file, fileList) {
      const listArr = this.uploadfileList;

      const uid = file.uid;
      const resultListArr = listArr.filter(item => item.uid !== uid);

      this.uploadfileList = resultListArr;
      this.$emit("valueFunc", this.paramsType, resultListArr);
    },

    /**
     * 确认上传
     * @param res
     */
    handleSuccess(res) {
      if (res.code === -1) {
        Message({
          message: res.msg,
          type: "error",
          duration: 3 * 1000
        });
        return;
      }
      const listArr = this.uploadfileList;
      const obj = {
        name: getFileName(res.data),
        url: res.data
      };
      listArr.push(obj);
      this.uploadfileList = listArr;
      this.$emit("valueFunc", this.paramsType, listArr);
    },

    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.maxCount} 个文件`);
    },

    beforeAvatarUpload(file) {
      console.log("file", file);
      console.log("size", file.size);
      console.log("type", file.type);
      const isJPG = [
        "video/mp4",
        "video/avi",
        "video/wmv",
        "video/mpg",
        "video/mpeg",
        "video/mov",
        "video/rm",
        "video/ram",
        "video/flv",
        "video/swf"
      ].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 50;

      if (!isJPG) {
        this.$message.error(
          "上传视频只能是 mp4,avi,wmv,mpg,mpeg,mov,rm,ram,flv,swf 格式!"
        );
      }
      if (!isLt2M) {
        this.$message.error("上传视频大小不能超过 50MB!");
      }
      return isJPG && isLt2M;
    }
  }
};
</script>
<style scoped lang="scss"></style>
